import React from "react";
import PermissionCell from "./PermissionCell";

const PermissionsItemRow = ({
  item,
  categoryId,
  formId, // For Forms Content (actual form ID)
  parentId, // For Forms (Applications parent ID)
  parentGroupId, // For Forms Content 4-level (Applications group ID)
  permissionTypes,
  onPermissionChange,
  isFlat = false,
  indentLevel = 2,
  isPermissionDisabled,
  isParentRow = false, // to identify parent rows (like Applications)
  formsContentType,
}) => {
  // Calculate padding based on indentation level and structure
  const getPaddingClass = () => {
    if (isFlat) return "pl-3"; // Flat items (miscellaneous)

    switch (indentLevel) {
      case 2:
        return "pl-8"; // Standard two-level (forms, tools, reports)
      case 3:
        return "pl-12"; // Three-level items
      case 4:
        return "pl-24"; // Four-level deepest items (properly indented after forms under Applications)
      default:
        return "pl-8";
    }
  };

  // Determine background class based on row type
  const getBackgroundClass = () => {
    if (isParentRow) {
      // Parent rows (like Applications) should have gray background
      return "bg-gray-300 border-t border-b border-gray-200";
    }
    // Regular items have light blue background
    return "hover:bg-gray-50 bg-customLightBlue text-black border-b border-dotted border-gray-300";
  };

  return (
    <tr className={getBackgroundClass()}>
      <td
        className={`${getPaddingClass()} py-2 text-sm ${
          isParentRow ? "font-medium text-gray-800" : ""
        }`}
      >
        {item.name}
      </td>
      {permissionTypes.map((permType) => {
        const disabled = isPermissionDisabled
          ? isPermissionDisabled(
              item.id,
              permType,
              categoryId,
              formId || parentId
            )
          : false;

        return (
          <PermissionCell
            key={permType}
            categoryId={categoryId}
            itemId={item.id}
            permissionType={permType}
            isEnabled={item.permissions[permType]}
            onPermissionChange={(catId, itemId, permType, newValue) => {
              if (parentGroupId && formId) {
                // Forms Content 4-level structure: Category > Parent Group > Form > Field/Tab
                onPermissionChange(catId, itemId, permType, newValue, {
                  parentGroupId,
                  formId,
                  contentType: formsContentType,
                });
              } else if (formId) {
                // Forms Content 3-level structure: Category > Form > Field/Tab
                onPermissionChange(catId, itemId, permType, newValue, {
                  formId,
                  contentType: formsContentType,
                });
              } else if (parentId) {
                // Forms Applications structure: Category > Applications > Application Types
                onPermissionChange(catId, itemId, permType, newValue, {
                  parentId,
                });
              } else {
                // Standard two-level structure
                onPermissionChange(catId, itemId, permType, newValue);
              }
            }}
            isCategory={false}
            disabled={disabled}
          />
        );
      })}
    </tr>
  );
};

export default PermissionsItemRow;
